import { render, staticRenderFns } from "./WorkerAdoption.vue?vue&type=template&id=2f293dc4&"
import script from "./WorkerAdoption.vue?vue&type=script&lang=js&"
export * from "./WorkerAdoption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports